import React, { useEffect, useState } from "react";
import {
  Button,
  Center,
  Heading,
  HStack,
  SimpleGrid,
  Spinner,
  Text,
  useToast,
} from "@chakra-ui/react";
import { ManualVideoModel } from "../services";
import { AddManualVideoModal, VideoCard } from "../components";

export default function ManualVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const fetchVideos = async () => {
    try {
      let response = await ManualVideoModel.get();
      setVideos(response.data.data);
    } catch (error) {
      toast({
        description: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  return (
    <>
      <HStack
        justifyContent="space-between"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={{ base: 0, md: "2" }}
      >
        <Heading fontSize={{ base: "xl", md: "3xl" }}>Videos</Heading>
        <AddManualVideoModal fetchVideos={fetchVideos} />
      </HStack>
      {loading ? (
        <Center my={3}>
          <Spinner />
        </Center>
      ) : videos.length ? (
        <SimpleGrid columns={{ base: 1, md: 3, lg: 4 }} gap={3}>
          {videos.map((item, i) => {
            return <VideoCard key={i} data={item} fetchVideos={fetchVideos} />;
          })}
        </SimpleGrid>
      ) : (
        <Text textAlign="center" color="gray">
          No Videos Found
        </Text>
      )}
    </>
  );
}
